<section>
  <header class="flex items-center mb-2">
    <h2 class="font-bold">
      {{ title }}
    </h2>

    <a
      class="ml-auto"
      app-vtmn-play-button
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [size]="vtmnPlayButtonSize.SMALL"
      [routerLink]="link"
    >
      {{ 'organizer.shared.edit_section.link' | translate }}
    </a>
  </header>

  <ng-content></ng-content>
</section>
